<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      title="Relevés de compte"
      subtitle="Recherche de relevés de compte"
      autocomplete_idHistory="account-statements"
      autocomplete_field="creancier.nom_soc || creancier.(nom prenom) || releve_compte.ID"
      bdTable="releve_compte"
      ref="releve_resource"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      :nobreadcrumb="nobreadcrumb"
      :nofacets="nofacets"
      :hiddenFilter="hiddenFilter"
      :nosearch="nosearch"
      :directLoad="directLoad"
    >
      <template #menu>
        <b-button
          v-if="!creancierID"
          size="sm"
          variant="secondary"
          class="ml-2"
          title="Gestion des relevés de compte"
          icon
          :to="{ name: 'manageAccountStatements' }"
          ><b-icon-file-earmark-text-fill></b-icon-file-earmark-text-fill></b-button
        >
        <b-button v-else  variant="secondary"
          class="ml-2"
          size="sm"
          title="Nouveau relevé de compte"
          :to="{ name: 'manageAccountStatements', params: { creancierID: creancierID } }">
          <b-icon-plus-square-fill></b-icon-plus-square-fill>
        </b-button>
      </template>

      <template v-slot:cell(ID)="data">
        <router-link
          :to="{ name: 'accountStatementView', params: { id: data.item.ID } }"
          >{{ data.item.ID }}</router-link
        >
      </template>
      <template v-slot:cell(balance)="data">
        <b class="text-success" v-if="data.value < 0"
          >{{ Number(data.value).toFixed(2) }} €</b
        >
        <b class="text-danger" v-else>{{ Number(data.value).toFixed(2) }} €</b>
      </template>
      <template v-slot:cell(creancier)="data">
        <b-link
          :to="{ name: 'creditorEdit', params: { id: data.item.creancierID } }"
          ><span v-html="company(data.value)"></span
        ></b-link>
      </template>
      <template v-slot:cell(factureID)="data">
        <b-link
          v-if="data.value"
          :to="{ name: 'invoiceView', params: { id: data.value } }"
          >{{ data.value }}</b-link
        >
        <span v-else>N/A</span>
      </template>
    </bd-table-list>
    <b-modal
      title="Envoyer le relevé de compte par mail"
      id="email-account"
      size="lg"
      title-class="text-center"
      hide-footer
    >
      <AccountStatementMail
        @close="$bvModal.hide('email-account')"
        object="relevé"
        :releve_id="releve_id"
      ></AccountStatementMail>
    </b-modal>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import accountStatements from "@/services/account-statements.js";
import AccountStatementMail from "@/components/AccountStatementMail";
export default {
  name: "AccountStatements",
  props: {
    nobreadcrumb: {
      type: Boolean,
      default: false,
    },
    nofacets: {
      type: Boolean,
      default: true,
    },
    hiddenFilter: String,
    nosearch: {
      type: Boolean,
      default: false,
    },
    directLoad: {
      type: Boolean,
      default: false,
    },
    creancierID: String
  },
  components: {
    BdTableList, AccountStatementMail
  },
  methods: {
    sendMail(payload) {
      this.releve_id = payload.ID;
      this.$bvModal.show("email-account");
    },
    deleteReleve(payload) {
      accountStatements.delete_releve({ releve_id: payload.ID }).then(() => {
        this.$bvToast.toast("Relevé de compte supprimé", {
          title: `Recuperator`,
          toaster: "b-toaster-top-right",
          variant: "success",
          autoHideDelay: 2000,
          solid: false,
        });
        this.$refs.releve_resource.submitSearch(false)
      });
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
  data() {
    return {
      Api: accountStatements,
      releve_id: null,
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Relevés de compte",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          to: "accountStatementView",
          icon: 'pencil-square',
          variant: 'success'
        },
        {
          label: "Envoyer par mail",
          action: (id) => this.sendMail({ ID: id }),
          icon: 'envelope-fill',
          variant: 'info'
        },
        {
          label: "Imprimer",
          href:
            this.$store.getters.url +
            "/account-statement/{id}/pdf?token=" +
            encodeURIComponent(localStorage.getItem("vue-token")),
          icon: 'printer-fill',
          variant: 'info'
        },
        {
          label: "Supprimer",
          action: (id) => this.deleteReleve({ ID: id }),
          icon: 'x-circle-fill',
          variant: 'danger',
          condition: () => this.$store.getters.isSuperAdmin
        },
      ],
      fields: [
        {
          key: "ID",
          label: "N° de relevé",
          sortable: true,
          class: "text-right",
          thStyle: "width:100px",
        },
        {
          key: "date_creation",
          label: "Date",
          sortable: true,
          formatter: (value) => {
            return this.toDate(value);
          },
        },
        {
          key: "creancier",
          label: "Créancier",
          sortable: true,
          class: 'text-truncate',
          thStyle: {width: '250px'},
        },
        {
          key: "report",
          label: "Solde précédent",
          sortable: true,
          class: "text-right",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "totalCreancier",
          label: "Total créancier",
          sortable: true,
          class: "text-right",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "totalChezNous",
          label: "Total chez nous",
          sortable: true,
          class: "text-right",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "totalChezVous",
          label: "Total chez vous",
          sortable: true,
          class: "text-right",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "balance",
          label: "Balance",
          sortable: true,
          class: "text-right",
        },
        {
          key: "factureID",
          label: "N° de facture",
          sortable: true,
          class: "text-right",
        },
        {
          key: "factureDate",
          label: "Date de facture",
          sortable: true,
          class:'text-center',
          formatter: (value, key, item) => {
            return item.factureID ? this.toDate(value) : "N/A";
          },
        },
        {
          key: "prixTVAC",
          label: "Montant de la facture (TVAC)",
          sortable: true,
          formatter: (value) =>
            value ? Number(value).toFixed(2) + " €" : "N/A",
          class: "text-right",
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
          thStyle: { width: '150px' },
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>